import { PLATFORM_ADMIN_ROLES } from './platform-admin-roles';

/**
 * Roles the PE Valuation surface admits, compared case-insensitively.
 *
 * Mirrors PE_USER_ROLES in `services/pe-valuation/src/middleware/auth.ts`, the
 * role gate `requireUserRole(PE_USER_ROLES)` runs on all three PE mounts after
 * the entitlement gate (GH #2657, operator ruling 2026-10-23, option 3a: the
 * FI-tenant roles plus platform admin). Every other role, `auditor` and
 * `partner` among them, gets 403 INSUFFICIENT_ROLE there, so the three PE nav
 * items and PeFeatureGate (routes/index.tsx) withhold the surface from it
 * (GH #4228). The SPA cannot import the service, so a change to the list there
 * changes it here in the same commit; PeFeatureGate.test.tsx reads the service
 * file and fails when the two differ.
 */
export const PE_USER_ROLES = [
  'fi_admin',
  'fi_loan_officer',
  'fi_compliance',
  'pledgor_advisor',
  ...PLATFORM_ADMIN_ROLES,
] as const;

/**
 * True when any role is a PE role; both sides lowercased. A non-string entry
 * never matches.
 */
export function hasPeRole(roles: readonly unknown[] | null | undefined): boolean {
  return (roles ?? []).some(
    (role) =>
      typeof role === 'string' &&
      (PE_USER_ROLES as readonly string[]).includes(role.toLowerCase()),
  );
}
